import 'regenerator-runtime/runtime';
import 'core-js/es6/promise';
import 'core-js/es6/set';
import 'core-js/es6/map';
import 'core-js/modules/es6.array.find';
import React, { Suspense } from 'react';
import ReactDOM from 'react-dom';
import { init as SentryInit } from '@sentry/browser';
import 'intersection-observer';
import { Provider } from 'react-redux';
import { createAuth } from '@jg/auth';
import { AuthProvider } from '@jg/auth-react';
import { I18nextProvider } from 'react-i18next';
import { ConnectedRouter } from 'connected-react-router';
import App from './App';
import ScrollToTop from './components/ScrollToTop/ScrollToTop';
import configureStore from './configureStore';
import config from './config';
import i18n from './i18next';
import history from './history';

const auth = createAuth(
  document,
  config.authCookieName,
  config.activeGroupCookieName,
  config.refreshAccessTokenApi,
);

if (config.sentry) {
  SentryInit(config.sentry);
}

const store = configureStore({}, history, auth);

const render = () => {
  ReactDOM.render(
    <Suspense fallback={<div />}>
      <Provider store={store}>
        <AuthProvider auth={auth}>
          <ConnectedRouter history={history}>
            <I18nextProvider i18n={i18n}>
              <ScrollToTop>
                <App />
              </ScrollToTop>
            </I18nextProvider>
          </ConnectedRouter>
        </AuthProvider>
      </Provider>
    </Suspense>,
    document.getElementById('root'),
  );
};
if (!auth.isConsumer()) {
  const redirectUrl = encodeURI(location.href);
  location.assign(`${config.loginURL}${redirectUrl}`);
} else if (!(window as any).Intl) {
  // Ensure only makes sure the module has been downloaded and parsed.
  (require as any).ensure([], () => {
    // eslint-disable-next-line
    require('intl');
    // Now we actually need to run it to install the polyfill.
    render();
  });
} else {
  render();
}
